import QueryResult from './QueryResult'

export default function DataFetcher(controller, searchers){
  this.async = true;
  this.controller = controller;
  this.searchers = searchers;
  this._isActive = true;
  this.onCancelHandlers = [];
  this.searcherStates = [];
  for (let i = 0; i < this.searchers.length; i++){
    this.searcherStates.push({"searcherId": this.searchers[i].getId(), "state": "pending"});
  }
  this.query = null;
  this.finalQueryResult = new QueryResult(null);
}

DataFetcher.prototype.fetch = function(query){
  //Do not move to async await. Needs to be parallel
  return new Promise((resolve)=>{
    this.query = query;
    for (let i = 0; i<this.searchers.length; i++){
      let searcher = this.searchers[i];
      searcher._fetchData(query).then(
        (queryResult) => {
          this.fetchSuccess(queryResult);
          if (!this.anyPending()){
            resolve(this.finalQueryResult);
          }
        },
        (error) => {
          this.fetchError(searcher, error);
          if (!this.anyPending()){
            resolve(this.finalQueryResult);
          }
        }
      );
    }
  });
};

DataFetcher.prototype.getQuery = function(){
  return this.query;
};

DataFetcher.prototype.cancel = function(){
  for (let i = 0; i < this.onCancelHandlers.length; i++){
    this.onCancelHandlers[i]();
  }
  this.clean();
};

DataFetcher.prototype.clean = function(){
  if (this._isActive){
    this._isActive = false;
    this.controller = null;
    this.onCancelHandlers = [];
    this.searcherStates = [];
  }
};

DataFetcher.prototype.fetchSuccess = function(queryResult){
  if (this._isActive){
    const searcher = queryResult.getSearcher();
    const searcherId = searcher.getId();
    for (let i = 0; i < this.searcherStates.length; i++){
      if (this.searcherStates[i].searcherId == searcherId){
        this.searcherStates[i].state = "complete";
        this.searcherStates[i].queryResult = queryResult;
        if (this.async){
          this.controller.fetchDataCallback(this, queryResult.getAllResults(), false);
        }
      }
    }
    if (!this.anyPending()){
      for (let i = 0; i < this.searcherStates.length; i++){
        let thisSearcherState = this.searcherStates[i];
        if (thisSearcherState.state == "complete"){
          let result = thisSearcherState.queryResult;
          this.finalQueryResult.addNewQueries(result.getNewQueries());
          this.finalQueryResult.addResults(result.getResults());
          this.finalQueryResult.addSuggestions(result.getSuggestions());
        }
      }
      this.controller.fetchDataCallback(this, this.finalQueryResult, true);
      this.clean();
    }
  }
};

DataFetcher.prototype.anyPending = function(){
  for (let j = 0; j < this.searcherStates.length; j++){
    if (this.searcherStates[j].state == "pending"){
      return true;
    }
  }
  return false;
};

DataFetcher.prototype.isActive = function(){
  return this._isActive;
};

DataFetcher.prototype.fetchError = function(searcher, errorThrown){
  if (this._isActive){
    const searcherId = searcher.getId();
    for (let i = 0; i < this.searcherStates.length; i++){
      if (this.searcherStates[i].searcherId == searcherId){
        this.searcherStates[i].state = "error";
      }
    }
    this.controller.fetchError(this, searcher, errorThrown);
    if (!this.anyPending()){
      for (let i = 0; i < this.searcherStates.length; i++){
        let thisSearcherState = this.searcherStates[i];
        if (thisSearcherState.state == "complete"){
          let result = thisSearcherState.queryResult;
          this.finalQueryResult.addNewQueries(result.getNewQueries());
          this.finalQueryResult.addResults(result.getResults());
          this.finalQueryResult.addSuggestions(result.getSuggestions());
        }
      }
      this.controller.fetchDataCallback(this, this.finalQueryResult, true);
      this.clean();
    }
  }
};
